import { render } from "./menu-item.vue?vue&type=template&id=3d18fb9c"
import script from "./menu-item.vue?vue&type=script&lang=js"
export * from "./menu-item.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/layouts/partials/sidebar/menu-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d18fb9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d18fb9c', __exports__)) {
    console.log('reload')
    api.reload('3d18fb9c', __exports__)
  }
  
  module.hot.accept("./menu-item.vue?vue&type=template&id=3d18fb9c", () => {
    console.log('re-render')
    api.rerender('3d18fb9c', render)
  })

}


export default __exports__